// Section states
import { CompanyState } from './sections/company/company.types';
import { FooterState } from './sections/footer/footer.types';
import { ProductsState } from './sections/products/products.types';
import { RequestState } from './sections/request/request.types';
import { SpacesState } from './sections/spaces/spaces.types';
import { StepsState } from './sections/steps/steps.types';
import { SystemsState } from './sections/systems/systems.types';

/**
 *  Available store mutation.
 */
export enum Mutation {
    /** Used to update the general loading state. */
    LOADING = 'loading',

    /** Used to update the internal state. */
    INTERNAL = 'internal',
}

/**
 *  Holding every property of the store.
 */
export interface RootState {
    /**
     *  The general loading state of the application.
     */
    loading: boolean;

    /**
     *  The internal state of the tool: if the tool is being used internally.
     */
    internal: boolean;

    /**
     *  The state of the request.
     */
    request: RequestState;

    /**
     *  The state of the steps.
     */
    steps: StepsState;

    /**
     *  The state of the systems.
     */
    systems: SystemsState;

    /**
     *  The state of the footer.
     */
    footer: FooterState;

    /**
     *  The state of the company.
     */
    company: CompanyState;

    /**
     *  The state of the spaces.
     */
    spaces: SpacesState;

    /**
     *  The state of the products.
     */
    products: ProductsState;
}

/**
 *  Also export every section's types for easy importing.
 */
export * from './sections/company/company.types';
export * from './sections/footer/footer.types';
export * from './sections/products/products.types';
export * from './sections/request/request.types';
export * from './sections/spaces/spaces.types';
export * from './sections/steps/steps.types';
export * from './sections/systems/systems.types';
